
    import '/opt/buildhome/repo/packages/x/components/prompts/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["prompts-demo-basic","prompts-demo-disabled","prompts-demo-flex-vertical","prompts-demo-flex-wrap","prompts-demo-flex-wrap-fixed","prompts-demo-nest","prompts-demo-fadein","prompts-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/prompts/index.zh-CN.md?type=demo')
};